import axios from "axios";
import api, { API } from "./api";
import { adminToken } from "./shopifyAdmin";
import { inAdminArea } from "./adminBase";

// Talks to /api/admin in two ways, decided per request by the page's area:
// - /shop-app (inside Shopify admin): a fresh Shopify session token on every request (never stored);
// - /admin (the new login): the session cookie, with the CSRF header and refresh-on-401 of the main api client.
const shopify = axios.create({ baseURL: `${API}/admin` });

shopify.interceptors.request.use(async (cfg) => {
  const token = await adminToken();
  cfg.headers["Authorization"] = `Bearer ${token}`;
  return cfg;
});

const login = {
  get: (url, cfg) => api.get(`/admin${url}`, cfg),
  delete: (url, cfg) => api.delete(`/admin${url}`, cfg),
  post: (url, data, cfg) => api.post(`/admin${url}`, data, cfg),
  put: (url, data, cfg) => api.put(`/admin${url}`, data, cfg),
  patch: (url, data, cfg) => api.patch(`/admin${url}`, data, cfg),
};

const client = () => (inAdminArea() ? login : shopify);

const adminApi = {
  get: (...a) => client().get(...a),
  delete: (...a) => client().delete(...a),
  post: (...a) => client().post(...a),
  put: (...a) => client().put(...a),
  patch: (...a) => client().patch(...a),
};

export default adminApi;

// Duck thumbnails / images come back as "/api/..." (backend-relative); prefix with the backend origin.
const BE = process.env.REACT_APP_BACKEND_URL || "";
export const adminImg = (url) => (!url ? url : url.startsWith("http") ? url : `${BE}${url}`);
